import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { LoadingPopupModule } from 'src/app/services/loadingPopup/loading-popup.module';
import { ComboBeneficiarioModule } from '../../common/combo-beneficiario/combo-beneficiario.module';
import { ComboPesquisavelModule } from '../../common/combo-pesquisavel/combo-pesquisavel.module';
import { ComboProgramaModule } from '../../common/combo-programa/combo-programa.module';
import { ComboProjetoModule } from '../../common/combo-projeto/combo-projeto.module';
import { RelatoriosHistoricoBeneficiarioRoutingModule } from './relatorios-historico-beneficiario-routing.module';
import { RelatoriosHistoricoBeneficiarioComponent } from './relatorios-historico-beneficiario.component';

@NgModule({
  declarations: [RelatoriosHistoricoBeneficiarioComponent],
  imports: [
    CommonModule,
    RelatoriosHistoricoBeneficiarioRoutingModule,
    MaterialCommonModule,
    LoadingPopupModule,
    ComboPesquisavelModule,
    ComboBeneficiarioModule,
    ComboProgramaModule,
    ComboProjetoModule,
  ]
})
export class RelatoriosHistoricoBeneficiarioModule { }
